export default {
  FORWARDER: "forwarder",
  INPUT_PROFILE: "forwarder#InputProfile"
};
